import styled from 'styled-components';
var FormAction = styled.div.withConfig({
  displayName: "FormAction",
  componentId: "v3r6p5-0"
})(["padding:0.5rem 1rem;"]);
export default FormAction;